import { MontantAnnuel } from './MontantAnnuel';
import { TypeAdresseCompleteMorale } from './TypeAdresseCompleteMorale';
import { TypeMontant } from './TypeMontant';
import { SousTraitanceOui } from './SousTraitanceOui';
import { Offres } from './Offres';

export class TypeAttributionMarcheLot {

  public montantIndefini: string;

  public montantAnnuel: MontantAnnuel;

  public trancheFerme: string;

  public trancheConditionnelle: string;

  public titulaire: TypeAdresseCompleteMorale;

  public sousTraitanceOui: SousTraitanceOui;

  public offres: Offres;

  public montant: TypeMontant;

  public sousTraitanceNon: string;

  public isSousTraitance: boolean;

  constructor() {
    this.montantIndefini = '';
    this.montantAnnuel = new MontantAnnuel();
    this.trancheFerme = '';
    this.trancheConditionnelle = '';
    this.titulaire = new TypeAdresseCompleteMorale();
    this.sousTraitanceOui = new SousTraitanceOui();
    this.offres = new Offres();
    this.montant = new TypeMontant();
    this.sousTraitanceNon = '';
    this.isSousTraitance = true;

  }
}
